const TextBulletsList = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2308 22.1462H25M13.2308 15.9154H25M13.2308 9.68466H25M9.76923 9.68466C9.76923 10.4494 9.14932 11.0693 8.38462 11.0693C7.61991 11.0693 7 10.4494 7 9.68466C7 8.91996 7.61991 8.30005 8.38462 8.30005C9.14932 8.30005 9.76923 8.91996 9.76923 9.68466ZM9.76923 15.9154C9.76923 16.6801 9.14932 17.3 8.38462 17.3C7.61991 17.3 7 16.6801 7 15.9154C7 15.1507 7.61991 14.5308 8.38462 14.5308C9.14932 14.5308 9.76923 15.1507 9.76923 15.9154ZM9.76923 22.1462C9.76923 22.9109 9.14932 23.5308 8.38462 23.5308C7.61991 23.5308 7 22.9109 7 22.1462C7 21.3815 7.61991 20.7616 8.38462 20.7616C9.14932 20.7616 9.76923 21.3815 9.76923 22.1462Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TextBulletsList;
